"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CompareSectionReducers = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _actionTypes = require("../actions/action-types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialSelectionState = {
  selectedVehicle: null,
  selectedModels: [],
  models: [],
  specificationGroups: [],
  subSpecificationGroups: []
};
var initialVehiclesDataState = {
  tabs: [],
  tables: [],
  models: [],
  specificationGroups: [],
  subSpecificationGroups: []
};

var isMatchingModel = function isMatchingModel(modelCode, selectedModelCode) {
  return modelCode === selectedModelCode;
};

var compareSelectionReducer = function compareSelectionReducer(state, action) {
  if (state === void 0) {
    state = initialSelectionState;
  }

  var refinedSelectedModels = state.models.map(function (model) {
    if (isMatchingModel(model.code, action.selectedModelCode)) {
      return _objectSpread(_objectSpread({}, model), {}, {
        selected: true
      });
    }

    return model;
  });
  var refinedDeselectedModels = state.models.map(function (model) {
    if (isMatchingModel(model.code, action.selectedModelCode)) {
      return _objectSpread(_objectSpread({}, model), {}, {
        selected: false
      });
    }

    return model;
  });

  switch (action.type) {
    case _actionTypes.SELECT_VEHICLE:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedVehicle: action.vehicle.code,
        selectedYear: Number(action.vehicle.year),
        selectedModels: []
      });

    case _actionTypes.DESELECT_VEHICLE:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedVehicle: null,
        selectedYear: null
      });

    case _actionTypes.GET_ALL_MODELS:
      return _objectSpread(_objectSpread({}, state), {}, {
        models: [].concat(action.models)
      });

    case _actionTypes.GET_ALL_SPECIFICATION_GROUPS:
      return _objectSpread(_objectSpread({}, state), {}, {
        specificationGroups: [].concat(action.specificationGroups)
      });

    case _actionTypes.GET_ALL_SUB_SPECIFICATION_GROUPS:
      return _objectSpread(_objectSpread({}, state), {}, {
        subSpecificationGroups: [].concat(action.subSpecificationGroups)
      });

    case _actionTypes.SELECT_MODEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        models: refinedSelectedModels
      });

    case _actionTypes.DESELECT_MODEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        models: refinedDeselectedModels
      });

    default:
      return state;
  }
};

var compareVehiclesDataReducer = function compareVehiclesDataReducer(state, action) {
  if (state === void 0) {
    state = initialVehiclesDataState;
  }

  switch (action.type) {
    case _actionTypes.GET_VEHICLE_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        models: action.data.models,
        specificationGroups: action.data.specificationGroups,
        subSpecificationGroups: action.data.subSpecificationGroups
      });

    case _actionTypes.CLEAR_VEHICLES_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        comparisonTable: null
      });

    default:
      return state;
  }
}; // eslint-disable-next-line import/prefer-default-export


var CompareSectionReducers = {
  compareSelection: compareSelectionReducer,
  compareVehiclesData: compareVehiclesDataReducer
};
exports.CompareSectionReducers = CompareSectionReducers;